import {BoostAppearDTO} from '@/domain/dtos/BoostDTO';
import {boostStore} from '@/entities/boost';
import {geoStore} from '@/entities/geo';

export function boostAppearHandler(model: BoostAppearDTO) {
  boostStore.add(model.boost, model.user);
  geoStore.addCity(model.city);
}
